/**
 * belgeTasimaNotu.js — bir belge kutusundaki küçük "taşındı" notu (backlog #145).
 * `GET /personnel/{personId}/belge-tasimalari` kişiye gelen / kişiden giden her taşımayı döner; kutuda
 * yalnızca BU kişinin şu anki dosyası için en yeni giriş gösterilir (hedef = bu kişi, aynı fileId).
 * Okuma başarısız olursa sayfa bozulmasın diye sessizce not yok sayılır.
 */
import { useEffect, useState } from "react";
import { getBelgeTasimalari } from "../../services/personelBelgeService";
import { FILE_APPROVAL_STATUS } from "../../services/projectService";
import i18n from "../../i18n";

const trTarih = (iso) => (iso ? String(iso).slice(0, 10).split("-").reverse().join(".") : "");

/** fileId → en yeni taşıma satırı (yalnızca `personId`ye GELENLER). */
export function useTasimaNotlari(personId, aktif, token = 0) {
  const [notlar, setNotlar] = useState(() => new Map());

  useEffect(() => {
    if (!aktif || !personId) return undefined;
    let ignore = false;
    async function run() {
      try {
        const rows = await getBelgeTasimalari(personId);
        if (ignore) return;
        const harita = new Map();
        // Liste en yeni önce: ilk görülen kazanır.
        rows.forEach((r) => {
          if (Number(r.hedefPersonId) === Number(personId) && !harita.has(r.fileId)) harita.set(r.fileId, r);
        });
        setNotlar(harita);
      } catch {
        if (!ignore) setNotlar(new Map());
      }
    }
    run();
    return () => { ignore = true; };
  }, [personId, aktif, token]);

  return notlar;
}

/** "Taşındı · önceki kişi: Ahmet Yılmaz · 30.09.2026 · önceki karar: Onaylandı" ya da null. */
export function tasimaNotu(satir) {
  if (!satir) return null;
  const kisiDegisti = Number(satir.kaynakPersonId) !== Number(satir.hedefPersonId);
  // Ek (-dan/-den) getirmiyoruz: kategori adlarına ve soyadlarına doğru ünlü uyumu kurmak mümkün değil.
  const kaynak = kisiDegisti
    ? i18n.t("components:belgeTasima.oncekiKisi", { v: [satir.kaynakAd, satir.kaynakSoyad].filter(Boolean).join(" ") || `#${satir.kaynakPersonId}` })
    : i18n.t("components:belgeTasima.oncekiKategori", { v: satir.eskiFileTypeAdi || `Tip ${satir.eskiFileTypeId}` });
  const parcalar = [i18n.t("components:belgeTasima.tasindi"), kaynak, trTarih(satir.tasimaTarihi)];
  if (satir.eskiOnayDurumu != null) {
    parcalar.push(i18n.t("components:belgeTasima.oncekiKarar", { v: FILE_APPROVAL_STATUS[satir.eskiOnayDurumu]?.label ?? satir.eskiOnayDurumu }));
  }
  return parcalar.filter(Boolean).join(" · ");
}
